import { gql } from '@apollo/client';

export const SendResetPasswordMutation = gql`
  mutation sendResetPasswordEmail($email: String!) {
    sendResetPasswordEmail(email: $email)
  }
`;
